import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import { Link, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { findRouteWithPath } from '@routes/routes';
import userApi from '@api/userApi';
import getSubRoutesItems from './getSubRoutesItems';
import styles from './SiderMenu.module.less';

const { Item, SubMenu, ItemGroup } = Menu;
let lastOpenKeys = [];

function SiderMenu(props) {

  const { routes, isCollapsed } = props;
  const { path: pathMatch } = useRouteMatch();
  const { t } = useTranslation();

  const abortC = new AbortController();
  const { signal } = abortC;

  const permissions = useSelector(({ user: u }) => u.get_all_permissions);
  const user = useSelector(({ user: u }) => u);

  const [openKeys, setOpenKeys] = useState(!isCollapsed ? lastOpenKeys : []);

  const [loadingMenu, setLoadingMenu] = useState(false);
  const [isClient, setIsClient] = useState(false);

  const keyTarget = useMemo(() => {

    const { key } = findRouteWithPath(pathMatch);
    return key;

  }, [pathMatch]);

  useEffect(() => {
    
    if(user.role !== 'Superadmin' ){
      userApi.getUserId({ id:user.id, signal })
      .then((response) => { 
        
        let isClient = false;

        // Verificar si algún tipo de negocio es "comunidades"
        response.business_types.forEach((businessType) => {
        if (businessType.type === 'Comunidades') {
          isClient = true;
          // Si se encuentra al menos un tipo de negocio "comunidades", salir del bucle
          return;
        }
        });

        // Establecer el estado basado en si es cliente o no
        setIsClient(isClient);
        setLoadingMenu(true);

      })
      .catch((resError) => {

         console.log('getUserId', resError)
         setLoadingMenu(true);
         setIsClient(false);
      }); 
      
    }else{
      setLoadingMenu(true);
      setIsClient(true);
    }
    

  }, []);

  useEffect(() => {

    lastOpenKeys = openKeys;

  }, [openKeys]);

  

  return (
    <Menu
      className={styles.menu}
      mode="inline"
      selectedKeys={[keyTarget]}
      onOpenChange={setOpenKeys}
      openKeys={openKeys}
    >
      {loadingMenu && routes.map((route) => {

        const {
          key, path, routes: subRoutes, menuItem: menuItemTemp,
        } = route;
        if (!menuItemTemp) return null;

        const menuItems = !Array.isArray(menuItemTemp) ? [menuItemTemp] : menuItemTemp;
        const items = [];
        // eslint-disable-next-line
        

        menuItems.forEach((menuItem) => {

          const {
            name,
            icon,
            isAbstract,
            isGroup,
            key: keyPath = key,
            path: pathItem = path,
          } = menuItem; 

         

          if (isAbstract && subRoutes) {

            return items.push(
              <SubMenu className={styles.submenu} key={keyPath} title={t(name)} icon={icon}>
                {getSubRoutesItems(subRoutes, permissions, t)}
              </SubMenu>,
            );

          }

          if (isGroup && subRoutes) {

            return items.push(
              <ItemGroup className={styles.itemSubmenu} key={keyPath} title={t(name)}>
                {getSubRoutesItems(subRoutes, permissions, t)}
              </ItemGroup>,
            );

          }

          // Si el elemento es para clientes y isClient es verdadero, agregarlo
          if (pathItem === '/clientes' && isClient) {
            items.push(
              <Item className={styles.item} icon={icon} key={keyPath}>
                <Link to={pathItem}>{t(name)}</Link>
              </Item>,
            );
          }
          
          // Si no es un elemento para clientes o isClient es falso, agregarlo
          if (pathItem !== '/clientes') {
            items.push(
              <Item className={styles.item} icon={icon} key={keyPath}>
                <Link to={pathItem}>{t(name)}</Link>
              </Item>,
            );
          }

          

        });

        return items;

      })}
    </Menu>
  );

}

SiderMenu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  isCollapsed: PropTypes.bool,
};

SiderMenu.defaultProps = {
  routes: [],
  isCollapsed: false,
};

export default SiderMenu;
